export default __webpack_public_path__ + "static/media/cart-black.dcd51680.svg";